import { AgGridReact } from 'ag-grid-react';
import { GetDefaultColDefs } from './renderers';
import { themeQuartz } from "ag-grid-community";

const myTheme = themeQuartz.withParams({
  borderColor: "#aaaaaa",
  wrapperBorder: false,
  headerRowBorder: false,
  rowBorder: { style: "solid", width: 1 },
  columnBorder: { style: "solid", width: 1 },
  fontSize: '15px',
  justifyContent: 'center',
  textAlign: 'center'
});

export function GetDGLoadingError(loading, error) {
    let str = error ? JSON.stringify(error) : (loading ? "Loading Data..." : "");

    return <p class="ld-str"> {str} </p>;
}

export function DataGrid(curRowData, onCheckboxChange, gridRef ) {
    return <AgGridReact
        ref={gridRef}
        rowData={curRowData}
        columnDefs={GetDefaultColDefs(onCheckboxChange)}
        rowHeight={220}
        pagination={true}
        headerHeight={100}
        theme={myTheme}
    />
}

